import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ListBox } from 'primereact/listbox';
import { Dialog } from 'primereact/dialog';
import AdicionUsuarioRol from './AdicionUsuarioRol';
import EliminaUsuarioRol from './EliminaUsuarioRol';
import { useAsignaRoles } from './useAsignaRoles';

const AsignaRoles = () => {
    const { miToast, visibleAdicion, setVisibleAdicion, guardaUsuario, visibleElimina, setVisibleElimina, rol, eliminaUsuario, cargaRoles, setRol, lstRoles, cargaUsuarios, usuario, lstUsuarios, setUsuario, abreAdiUsuario, abreELiUsuario } =
        useAsignaRoles();
    return (
        <div className="card">
            <Toast ref={miToast} />
            <Dialog header="Adicion de Usuario" visible={visibleAdicion} onHide={() => setVisibleAdicion(false)} style={{ width: '50vw' }}>
                <AdicionUsuarioRol onSave={guardaUsuario} tituloRol={rol?.nombre} />
            </Dialog>
            <Dialog header="Elimina Usuarios" visible={visibleElimina} onHide={() => setVisibleElimina(false)} style={{ width: '50vw' }}>
                <EliminaUsuarioRol rol={rol} lstUser={usuario} onElimina={eliminaUsuario} />
            </Dialog>
            <h5>Asignación de Roles a Usuarios</h5>
            <div className="formgrid grid p-fluid mb-3">
                {/* Roles */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboProyecto">Roles :</label>
                    {cargaRoles ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown id="cboProyecto" value={rol} onChange={(e) => setRol(e.value)} options={lstRoles} placeholder="Selecciona un rol" optionLabel="nombre" filter showClear />
                    )}
                </div>
                {/* Usuarios */}
                <div className="field col-12 md:col-4">
                    <label htmlFor="cboProyecto">Roles</label>
                    {cargaUsuarios ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <ListBox filter multiple value={usuario} options={lstUsuarios} onChange={(e) => setUsuario(e.value)} optionLabel="usuarioUserName" className="w-full " listStyle={{ height: '200px' }} />
                    )}
                </div>
                {/* Botones */}
                <div className="field col-12 md:col-2">
                    <div className="grid justify-content-end ">
                        {/* Cada botón va dentro de un div con col-12 */}
                        <div className="col-12">
                            <span> </span>
                        </div>
                        <div className="col-12">
                            <div className="h-4"></div>
                        </div>
                        <div className="col-12">
                            <Button icon="pi pi-plus" aria-label="Button 1" onClick={abreAdiUsuario} tooltip="Adicionar usuario" />
                        </div>
                        <div className="col-12 mt-2">
                            <Button icon="pi pi-minus" aria-label="Button 2" onClick={abreELiUsuario} tooltip="Quitar usuario del rol" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AsignaRoles;
